import { z } from "zod";

/**
 * Hesap seviyesi dil ve görünüm tercihleri (CLOS-105 `[066]`).
 *
 * ⚠ Tercih HESABA bağlı, çalışma alanına DEĞİL. Kartın ilk iki kriteri bunu şart koşuyor:
 * *"tercih gerçek kullanıcı hesabına bağlı ve çalışma alanlarından bağımsız korunur"*,
 * *"çalışma alanı değişiminde kaybolmaz veya tenant verisine dönüşmez."* Bu yüzden
 * `users` tablosunda duruyor ve hiçbir tenant sorgusuna karışmıyor.
 */

/**
 * Görünüm tercihi.
 *
 * `system` bir ÜÇÜNCÜ tema değil, bir DELEGASYON: kullanıcı kararı işletim sistemine
 * bırakıyor. Bu yüzden çözümleme (hangi tema uygulanacak) istemcide yapılıyor ve
 * saklanan değer `system` olarak kalıyor — çözümlenmiş değeri saklasaydık kullanıcının
 * işletim sistemi değiştiğinde tercihi sessizce donardı.
 */
export const APP_THEMES = ["light", "dark", "system"] as const;
export type AppTheme = (typeof APP_THEMES)[number];

export const APP_THEME_NAMES: Record<AppTheme, string> = {
  light: "Açık",
  dark: "Koyu",
  system: "Sistem",
};

/** Uygulanan tema — `system` çözümlendikten SONRAKİ değer. */
export const RESOLVED_THEMES = ["light", "dark"] as const;
export type ResolvedTheme = (typeof RESOLVED_THEMES)[number];

/**
 * ⚠ VARSAYILAN AÇIK TEMA — ürün sahibi kararı (4 Eylül 2026). Önce `system`'di ve yeni
 * kullanıcı işletim sistemi koyudaysa ürünü koyu görüyordu; ürünün kendi kimliği açık
 * tema. `system` bir tercih olarak yerinde duruyor, yalnız başlangıç değeri değil.
 *
 * Bozuk bir değerin düştüğü güvenli varsayılan da bu: belirsizlikte ürün kendi kimliğini
 * gösteriyor, işletim sistemine devretmiyor.
 */
export const DEFAULT_THEME: AppTheme = "light";

/**
 * Desteklenmeyen ya da bozuk bir tercih GÜVENLİ VARSAYILANA düşüyor (kart kriteri).
 *
 * Veritabanında eski bir değer kalmış ya da biri elle `"neon"` yazmış olabilir; ekranın
 * bu yüzden boş kalması ya da patlaması kabul edilemez.
 */
export function safeTheme(value: unknown): AppTheme {
  return (APP_THEMES as readonly unknown[]).includes(value) ? (value as AppTheme) : DEFAULT_THEME;
}

export const localeConfigSchema = z.object({
  supported: z.array(z.string().min(2)).min(1),
  default: z.string().min(2),
});
export type LocaleConfig = z.infer<typeof localeConfigSchema>;

export const updatePreferencesSchema = z.object({
  theme: z.enum(APP_THEMES).optional(),
  locale: z.string().trim().min(2, "Dil kodu geçersiz").max(16, "Dil kodu çok uzun").optional(),
});
export type UpdatePreferencesInput = z.infer<typeof updatePreferencesSchema>;

export const preferencesSchema = z.object({
  theme: z.enum(APP_THEMES),
  locale: z.string(),
  /** Seçilebilir diller — sunucudan gelir; arayüz kendi listesini tutmaz. */
  supportedLocales: z.array(z.string()),
});
export type Preferences = z.infer<typeof preferencesSchema>;
